<template>
  <base-page-layout class="arvore-produtos" title="Árvore de produtos">
    <arvore-produtos-component />
  </base-page-layout>
</template>

<script>
import BasePageLayout from '@/components/BasePageLayout.vue'
import ArvoreProdutosComponent from '@/components/ArvoreProdutosComponent.vue'

export default {
  components: {
    BasePageLayout,
    ArvoreProdutosComponent,
  },
}
</script>
